import React, {useEffect, useState} from "react";
import {useDeleteDepartment, useListAllDepartments} from "../../services/department/apiDepartments";
import CustomTable, {TypeItemTable} from "../../components/general/CustomTable";
import {DepartmentInterface} from "../../services/interface/DepartmentInterface";
import CustomButton from "../../components/general/CustomButton";
import {useTranslation} from "react-i18next";
import CustomIcon from "../../components/general/CustomIcon";
import DialogCreateDepartment from "./DialogCreateDepartment";
import {IconButton} from "@material-tailwind/react";
import * as Icons from "@mui/icons-material";
import {showToast} from "../../components/general/CustomToast";

export default function Departments() {
    const {t} = useTranslation("global") as { t: (key: string) => string }
    const {refetch: findAllDepartments, isPending, data} = useListAllDepartments()

    const [title, setTitle] = useState(t('create-department'))
    const [open, setOpen] = useState(false)

    const [department, setDepartment] = React.useState<DepartmentInterface | undefined>()
    const [list, setList] = React.useState<DepartmentInterface[] | undefined>()
    const [listElement, setListElement] = useState<TypeItemTable[] | undefined>()

    const {mutate: deleteDepartment, data: successDelete} = useDeleteDepartment()

    useEffect(() => {
        findAllDepartments({});
    }, []);

    useEffect(() => {
        if (data && data.length > 0) {
            setList(data)
        }
    }, [data]);

    useEffect(() => {
        if (successDelete) {
            showToast(t('success-delete-department'), 'success')
        }
    }, [successDelete]);

    useEffect(() => {
        if (list) {
            setListElement(list.map((item, index) => ({
                row: [
                    item.name,
                    item.description ? item.description : '-',
                    <div className={'flex items-center justify-center'}>
                        {item.icon ? <CustomIcon iconName={item.icon}/> : <>-</>}
                    </div>,
                    <div className={'flex justify-center gap-2 py-1'}>
                        <IconButton key={`key-edit-${index}`} placeholder="icon-button" variant="text" color="blue"
                                    onClick={() => {
                                        setDepartment(item)
                                        setTitle(t('edit-department'))
                                        setOpen(true)
                                    }}>
                            <Icons.Edit className="w-5 text-gray-600"/>
                        </IconButton>
                        <IconButton key={`key-delete-${index}`} placeholder="icon-button" variant="text" color="blue"
                                    onClick={() => {
                                        showToast(`${t('confirm-delete-department')} ${item.name}`, 'warning', () => {
                                            deleteDepartment(item)
                                        })
                                    }}>
                            <Icons.Delete className="w-5 text-gray-600"/>
                        </IconButton>
                    </div>,
                ]
            })))
        }
    }, [list]);

    return(
        <div className={'flex flex-col md:px-20 pt-6 gap-3'}>
            {open && <DialogCreateDepartment {...{department, title, open, setOpen}}/>}
            <div className={'flex flex-row items-center'}>
                <h3>{t('admin-user')}</h3>
                <CustomButton
                    className={'ml-auto bg-primary'}
                    text={t('create-department')}
                    onClick={() => {
                        setDepartment(undefined)
                        setTitle(t('create-department'))
                        setOpen(true)
                    }}
                />
            </div>
            <CustomTable
                loading={isPending}
                highTable={'552px'}
                header={[
                    t('name'),
                    t('description'),
                    t('icon'),
                    t('action'),
                ]}
                {...{listElement}}
            />
        </div>
    )
}
